import React from 'react';
import SbEditable from 'storyblok-react';

import StoryblokComponents from '../storyblok/StoryblokComponents';

type RenderStoryblokComponentsProps = {
  blocks?: any[];
  preProps?: any;
  postProps?: any;
  colourScheme?: 'white' | 'darkGreen' | 'grey' | string | number | undefined;
  childClassName?: string;
};

const renderStoryblokComponents = ({
  blocks,
  preProps = {},
  postProps = {},
  colourScheme,
  childClassName,
}: RenderStoryblokComponentsProps) => {
  if (!blocks) {
    return null;
  }

  return blocks?.map((block) => (
    <SbEditable key={'_' + block._uid} content={block}>
      {React.createElement(StoryblokComponents(block.component), {
        key: block._uid,
        ...preProps,
        ...block,
        ...postProps,
        colourScheme: block?.colourScheme || colourScheme,
        childClassName: childClassName,
      })}
    </SbEditable>
  ));
};

export default renderStoryblokComponents;
